var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSimpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 0.666626C46.2004 0.666626 59.3334 13.7996 59.3334 30C59.3334 46.2003 46.2004 59.3333 30.0001 59.3333C13.7997 59.3333 0.666748 46.2003 0.666748 30C0.666748 13.7996 13.7997 0.666626 30.0001 0.666626ZM30.0001 5.99996C16.7452 5.99996 6.00008 16.7451 6.00008 30C6.00008 43.2548 16.7452 54 30.0001 54C43.2549 54 54.0001 43.2548 54.0001 30C54.0001 16.7451 43.2549 5.99996 30.0001 5.99996ZM31.6667 27.3333C32.219 27.3333 32.6667 27.781 32.6667 28.3333V42.3333C32.6667 42.8856 32.219 43.3333 31.6667 43.3333H28.3334C27.7811 43.3333 27.3334 42.8856 27.3334 42.3333V28.3333C27.3334 27.781 27.7811 27.3333 28.3334 27.3333H31.6667ZM30.0001 19.3333C31.4728 19.3333 32.6667 20.5272 32.6667 22C32.6667 23.4727 31.4728 24.6666 30.0001 24.6666C28.5273 24.6666 27.3334 23.4727 27.3334 22C27.3334 20.5272 28.5273 19.3333 30.0001 19.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSimpleIcon);
export default __webpack_public_path__ + "static/media/InfoSimpleIcon.63221da2f9e7bd313c43c0ef428a602d.svg";
export { ForwardRef as ReactComponent };